import { createContext, useContext } from 'react'

/**
 * Field control density. `regular` is the default calibration (16px values,
 * 38px controls). `compact` shrinks controls proportionally (14px values,
 * ~32px controls) for dense composition UIs — panels where several controls
 * form one sentence and comprehension comes from seeing the whole row at
 * once. Labels keep their 12px/450 styling in both densities.
 *
 * Provided per-surface (e.g. the automation editor side panel) so simple
 * forms elsewhere keep the regular scale.
 */
export type FieldDensity = 'regular' | 'compact'

export const FieldDensityContext = createContext<FieldDensity>('regular')

export function useFieldDensity(): FieldDensity {
  return useContext(FieldDensityContext)
}
